import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signin-check_email-view';

/**
 * Event that will be triggered when the Check Email screen is viewed with its screen type.

Screen type can be:
- magic_link
- mfa_required
- mfa_email
- incorrect_password
 */
export function trackSigninCheckEmailView(
  Screen_type_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Screen_type_string },
  });
}
